
import img1 from '../images/icon/icon1.png'
import img2 from '../images/icon/icon2.png'
import img3 from '../images/icon/icon3.png'
import img4 from '../images/icon/icon4.png'


const dataBox = [

    {
        id: 1,
        img: img1,
        title: 'Secure Matches',
        desc: ' Ensuring private rooms with strict access controls to prevent unauthorized players.'
    },
    {
        id: 2,
        img: img2,
        title: 'Exciting Prizes',
        desc: ' Rewarding competetive winners with attractive prizes to celebrate their skills.'
    },
    {
        id: 3,
        img: img3,
        title: 'Fair Play Guarantee',
        desc: 'Promoting skill-based competition with zero tolerance for cheating'
    },
    {
        id: 4,
        img: img4,
        title: 'Community Engagement',
        desc: 'Connecting PUBG enthusiasts through thrilling tournaments and events.'
    },

]

export default dataBox;